var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-xs-12 p-24" },
    [
      _c(
        "div",
        {
          staticClass:
            "page-title mb-30 d-flex align-items-center col-gap-20 col-xs-12 col-sm-6 col-md-7 p-0",
        },
        [
          _c("img", {
            staticClass: "cursor-pointer",
            attrs: {
              src: "/static/images/icons/chevron_left.svg",
              alt: "download-icon",
            },
            on: { click: _vm.navigateBack },
          }),
          _c("span", { staticClass: "text-capitalize" }, [
            _vm._v(
              _vm._s(_vm.actionType) +
                " " +
                _vm._s(
                  _vm.headLineType === "mainheadline"
                    ? "headline"
                    : "Feature content"
                )
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "col-xs-12 p-0 mb-30" }, [
        _vm._m(0),
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.$v.formDetails.title.$model,
                expression: "$v.formDetails.title.$model",
              },
            ],
            staticClass: "form-control",
            attrs: { maxlength: "130", type: "text" },
            domProps: { value: _vm.$v.formDetails.title.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.$v.formDetails.title,
                  "$model",
                  $event.target.value
                )
              },
            },
          }),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "col-xs-12 p-0 mb-30",
          class: [
            _vm.headLineType === "mainheadline"
              ? "d-flex col-gap-24 xs-flex-column"
              : "",
          ],
        },
        [
          _vm.headLineType === "mainheadline"
            ? [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 p-0 custom-date-picker" },
                  [
                    _vm._m(1),
                    _c("date-picker", {
                      attrs: {
                        type: "date",
                        format: "DD/MM/YYYY",
                        valueType: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
                        editable: false,
                        placeholder: "DD/MM/YYYY",
                        "append-to-body": false,
                        "popup-style": { top: 10, left: 0, marginTop: "10px" },
                      },
                      model: {
                        value: _vm.$v.formDetails.display_date.$model,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.$v.formDetails.display_date,
                            "$model",
                            $$v
                          )
                        },
                        expression: "$v.formDetails.display_date.$model",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm.headLineType === "featuredcontent"
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 p-0 d-flex col-gap-24 xs-flex-column mb-30",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-6 p-0 custom-date-picker",
                      },
                      [
                        _vm._m(2),
                        _c("date-picker", {
                          attrs: {
                            type: "date",
                            format: "DD/MM/YYYY",
                            valueType: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
                            editable: false,
                            placeholder: "DD/MM/YYYY",
                            "append-to-body": false,
                            "popup-style": {
                              top: 10,
                              left: 0,
                              marginTop: "10px",
                            },
                          },
                          model: {
                            value: _vm.$v.formDetails.start_date.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.formDetails.start_date,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.formDetails.start_date.$model",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-6 p-0 custom-date-picker",
                      },
                      [
                        _vm._m(3),
                        _c("date-picker", {
                          attrs: {
                            type: "date",
                            format: "DD/MM/YYYY",
                            valueType: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
                            editable: false,
                            placeholder: "DD/MM/YYYY",
                            "append-to-body": false,
                            "popup-style": {
                              top: 10,
                              left: 0,
                              marginTop: "10px",
                            },
                          },
                          model: {
                            value: _vm.$v.formDetails.end_date.$model,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$v.formDetails.end_date,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.formDetails.end_date.$model",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "col-xs-12 p-0",
              class: [
                _vm.headLineType === "mainheadline" ? "col-sm-6" : "col-sm-12",
              ],
            },
            [
              _c("label", [_vm._v("Website Link")]),
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.formDetails.redirection_url.$model,
                      expression: "$v.formDetails.redirection_url.$model",
                    },
                  ],
                  staticClass: "form-control common-input",
                  class: {
                    "invalid-border": _vm.$v.formDetails.redirection_url.$error,
                  },
                  attrs: { placeholder: "http://", type: "text" },
                  domProps: {
                    value: _vm.$v.formDetails.redirection_url.$model,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.formDetails.redirection_url,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm.$v.formDetails.redirection_url.$error
                ? _c("div", { staticClass: "custom-error-class pt-5" }, [
                    _vm._v(" Please enter valid URL "),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        2
      ),
      _c("div", { staticClass: "col-xs-12 p-0 mb-30" }, [
        _vm._m(4),
        _c("div", { staticClass: "form-group" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.$v.formDetails.description.$model,
                expression: "$v.formDetails.description.$model",
              },
            ],
            staticClass: "form-control common-input",
            attrs: { maxlength: "300", type: "text", rows: "5" },
            domProps: { value: _vm.$v.formDetails.description.$model },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.$v.formDetails.description,
                  "$model",
                  $event.target.value
                )
              },
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "col-xs-12 col-sm-12 p-0 mb-20" }, [
        _vm._m(5),
        _c(
          "div",
          {
            staticClass:
              "upload-area d-flex flex-direction-column justify-content-center align-items-center row-gap-20",
            on: {
              drop: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.getDroppedFile.apply(null, arguments)
              },
              dragover: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.onDragOver.apply(null, arguments)
              },
            },
          },
          [
            _vm._m(6),
            _c("input", {
              ref: "headLineFile",
              staticClass: "hidden",
              attrs: { type: "file", id: "newHeadLine" },
              on: { change: _vm.setSelectedFile },
            }),
            _c(
              "button",
              {
                staticClass: "btn emergo-blue-button upload-button w-160",
                attrs: { for: "newHeadLine" },
                on: { click: _vm.openFileUpload },
              },
              [_vm._v(" Upload ")]
            ),
            _vm.fileName
              ? _c("div", { staticClass: "selected d-flex" }, [
                  _c("div", { staticClass: "pr-15 word-break" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("decodeFileName")(
                            _vm.actionType === "add"
                              ? _vm.fileName
                              : _vm.fileName
                          )
                        ) +
                        " "
                    ),
                  ]),
                  _c("img", {
                    staticClass: "cursor-pointer small",
                    attrs: {
                      src: "/static/images/icons/danger_close_icon.svg",
                    },
                    on: { click: _vm.clearSelectedFile },
                  }),
                ])
              : _vm._e(),
            _vm.errorText
              ? _c("div", { staticClass: "col-xs-12 text-center" }, [
                  _c("div", { staticClass: "error-message danger" }, [
                    _vm._v(_vm._s(_vm.errorText)),
                  ]),
                ])
              : _vm._e(),
          ]
        ),
      ]),
      _c(
        "div",
        {
          staticClass:
            "col-xs-12 p-0 mt-5 d-flex justify-content-end col-gap-15",
        },
        [
          _c(
            "button",
            {
              staticClass: "btn emergo-white-button w-124",
              on: { click: _vm.navigateBack },
            },
            [_vm._v("Cancel")]
          ),
          _c(
            "button",
            {
              staticClass: "btn emergo-green-button w-124",
              attrs: { disabled: _vm.disabledSave },
              on: { click: _vm.addEditHeadLine },
            },
            [_vm._v(" Save ")]
          ),
        ]
      ),
      _c("discard-form-changes-popup", {
        on: { navigateBackToListView: _vm.discardAllFormChanges },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Headline "),
      _c("span", { staticClass: "danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Date "),
      _c("span", { staticClass: "danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Start Date "),
      _c("span", { staticClass: "danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("End Date "),
      _c("span", { staticClass: "danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Description (max 300 Character) "),
      _c("span", { staticClass: "danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Upload "),
      _c("span", { staticClass: "danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "d-flex flex-direction-column align-items-center row-gap-20",
      },
      [
        _c("img", {
          attrs: {
            src: "/static/images/icons/new_upload_file_icon.svg",
            alt: "",
          },
        }),
        _c("span", { staticClass: "file-header-text fw-400" }, [
          _vm._v(
            "Click the button “Upload File” button or drag a .jpg or .png file here"
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }